export class MClient {

  constructor(
    public id: number,
    public balanceCc: string,
    public balancePrizes: string,
	public fecha_alta: string,
	public autoingreso?: number,
  ) {}

  public getSaldoTotal(): number {
    return Number((parseFloat(this.balanceCc) + parseFloat(this.balancePrizes)).toFixed(2))
  }

}
